import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Card,
  Image,
  SegmentedControl,
  Text,
  TextInput,
  Flex,
} from "@mantine/core";

import { PaginatedList } from "@components/shared";
import entityColor from "@util/entityColor";
import { affiliateVarieties, affiliateClassifications } from "./helpers";

export default function AffiliateList({
  isIndex,
  items = null,
  requestInfo = {
    url: `/retrieve-affiliates/`,
    data: {},
  },
  refresh,
}) {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const [filters, setFilters] = useState({
    status: "active",
    variety: "all",
    classification: "all",
  });
  const [refresh2, setRefresh2] = useState(false);

  const statusButtons = [
    // { label: "All", value: "all" },
    { label: t("common:active"), value: "active" },
    { label: t("common:inactive"), value: "inactive" },
    // { label: "Deleted", value: "3" },
  ];

  const classificationButtons = [
    { label: t("common:all"), value: "all", color: "" },
    ...affiliateClassifications.map((m) => ({
      label: m.label,
      value: m.value,
      color: entityColor.affiliate,
    })),
  ].map((m, i) => ({
    ...m,
    key: i,
  }));

  const reqData = {
    ...filters,
    ...requestInfo.data,
    search_value: searchValue,
    refresh,
    refresh2,
    variety: filters.variety === "all" ? [1, 2, 3] : filters.variety,
    classification:
      filters.classification === "all" ? [1, 2] : filters.classification,
  };

  return (
    <div>
      {requestInfo && (
        <React.Fragment>
          <TextInput
            placeholder="Search for an affiliate..."
            size="lg"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </React.Fragment>
      )}
      <Flex gap="sm" align="center" mb="sm" mt="sm">
        <SegmentedControl
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e })}
          data={statusButtons}
        />
        <SegmentedControl
          value={filters.classification}
          onChange={(e) => setFilters({ ...filters, classification: e })}
          data={classificationButtons}
        />
      </Flex>
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m, i) => ({
            ...m,
            key: i,
            link_url: `/affiliates/${m.id}`,
          }))
        }
        displayFormatter={(item) => (
          <Card key={item.original.id}>
            {item.original.image && (
              <Card.Section>
                <Image
                  src={item.original.image}
                  height={250}
                  alt={`${item.original.title} photo`}
                />
              </Card.Section>
            )}
            <Flex align="center" gap="xs">
              <div style={{ flexGrow: 1 }}>
                <Text fw={700} component={Link} to={item.original.link_url}>
                  {item.original.name}
                </Text>
              </div>
            </Flex>
          </Card>
        )}
      />
    </div>
  );
}
